export class Check {
    public static TYPE_NORMAL: string = 'NORMAL';
    public static TYPE_FORCED: string = 'FORCED';

    public connectionType: string;
    public date: number;
    public event: string;
    public latitude: string;
    public longitude: string;
    public type: string;
    public userId: string;
    public mac: string;
    public timestamp: number;

    // Other fields
    public user: any;

    /**
     * @param {string} event IN or OUT
     * @param {number} date in timestamps format
     */
    constructor(event: string, date: number) {
        this.event = event;
        this.date = date;
    }
}



// WEBPACK FOOTER //
// ./src/models/Check.ts